document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".geyser-sidebar")) return;

  /* ===============================
     Fancybox
  =============================== */
  if (window.Fancybox) {
    Fancybox.bind("[data-fancybox]", {
      Carousel: {
        Thumbs: true,
        Toolbar: {
          display: { left: [], middle: [], right: ["close"] },
        },
        Zoomable: {
          Panzoom: {
            maxScale: "cover",
            panMode: "mousemove",
            mouseMoveFactor: 1.1,
          },
        },
      },
    });
  }

  /* ===============================
     jQuery logic
  =============================== */
  if (typeof window.jQuery === "undefined") return;
  const $ = window.jQuery;

  $(function () {
    const videoPositions = {};
    const manuallyPaused = new Set();

    /* -----------------------------
       Save video position
    ----------------------------- */
    $(window).on("beforeunload", function () {
      $(".geyser-item video").each(function () {
        const id = $(this).closest(".geyser-item").attr("id");
        if (id && !this.paused) {
          videoPositions[id] = this.currentTime;
        }
      });
      localStorage.setItem("videoPositions", JSON.stringify(videoPositions));
    });

    /* -----------------------------
       Sidebar click scroll
    ----------------------------- */
    $(".geyser-sidebar li").on("click", function () {
      const target = $(this).data("target");

      $(".geyser-sidebar li").removeClass("active-geyser");
      $(this).addClass("active-geyser");

      $("html, body").animate({ scrollTop: $(target).offset().top - 100 }, 600);
    });

    /* -----------------------------
       Sidebar scroll detection
    ----------------------------- */
    const spaRevealPoint = $("#spa").offset()?.top - 150 || 0;

    $(window).on("scroll", function () {
      const isMobile = window.innerWidth <= 768;
      const $sidebar = $(".geyser-sidebar");
      const $spa = $("#spa");
      const $sauna = $("#sauna");

      if (!$spa.length || !$sauna.length) return;

      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();

      const sectionTop = $spa.offset().top;
      const sectionBottom = $sauna.offset().top + $sauna.outerHeight();

      if (
        windowTop >= spaRevealPoint &&
        windowBottom >= sectionTop &&
        windowTop < sectionBottom
      ) {
        $sidebar.addClass("is-visible");
      } else {
        $sidebar.removeClass("is-visible");
      }

      let activeFound = false;

      $(".geyser-item").each(function () {
        const itemTop = $(this).offset().top;
        const itemBottom = itemTop + $(this).outerHeight();
        const id = `#${this.id}`;

        let isActive = false;

        if (isMobile) {
          const visible = Math.max(0, windowBottom - itemTop);
          isActive = (visible / $(this).outerHeight()) * 100 >= 10;
        } else {
          const trigger = windowTop + $(window).height() * 0.3;
          isActive = trigger >= itemTop && trigger < itemBottom;
        }

        if (isActive) {
          $(".geyser-sidebar li").removeClass("active-geyser");
          $(`.geyser-sidebar li[data-target="${id}"]`).addClass(
            "active-geyser",
          );
          activeFound = true;
        }
      });

      if (!activeFound) {
        $(".geyser-sidebar li").removeClass("active-geyser");
      }
    });
  });
});

$(document).ready(function () {
  // Video lazy loading
  const videos = document.querySelectorAll(".geyser-item video");
  const manuallyPaused = new Set();

  const muteSVG = `  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2353_983)">
      <path d="M20.5424 12.0515L30.4443 2.98902C30.4806 2.95586 30.5257 2.93395 30.5741 2.92598C30.6226 2.918 30.6724 2.92429 30.7173 2.94409C30.7623 2.96389 30.8005 2.99634 30.8273 3.03749C30.8542 3.07863 30.8685 3.1267 30.8685 3.17582V23.5493C30.8685 23.8809 31.0002 24.1988 31.2346 24.4332C31.469 24.6676 31.7869 24.7993 32.1185 24.7993C32.45 24.7993 32.7679 24.6676 33.0023 24.4332C33.2368 24.1988 33.3685 23.8809 33.3685 23.5493V3.17566C33.3685 2.64146 33.2132 2.11878 32.9214 1.67132C32.6295 1.22387 32.2138 0.870978 31.725 0.655663C31.2361 0.440348 30.6951 0.371911 30.168 0.458693C29.6409 0.545476 29.1504 0.783731 28.7564 1.14441L18.8546 10.2069C18.61 10.4307 18.4644 10.7426 18.4497 11.0738C18.4351 11.405 18.5526 11.7284 18.7764 11.973C19.0002 12.2175 19.312 12.3632 19.6432 12.3778C19.9744 12.3925 20.2979 12.275 20.5424 12.0511V12.0515Z" fill="white"/>
      <path d="M39.1827 37.4151L2.5848 0.817066C2.3499 0.584996 2.03271 0.455302 1.7025 0.456305C1.3723 0.457307 1.05591 0.588924 0.822415 0.822415C0.588925 1.05591 0.457307 1.3723 0.456305 1.7025C0.455302 2.03271 0.584997 2.3499 0.817066 2.5848L10.0218 11.7896C9.04438 12.0763 8.18593 12.6715 7.57479 13.4864C6.96364 14.3013 6.63262 15.2921 6.63121 16.3107V23.6893C6.63255 24.9383 7.12931 26.1357 8.01249 27.0189C8.89567 27.9021 10.0931 28.3988 11.3421 28.4002H17.333L28.7564 38.8555C29.2587 39.3218 29.9183 39.5817 30.6036 39.5835C30.9899 39.5826 31.3718 39.5011 31.7249 39.3443C32.2164 39.1327 32.6345 38.7807 32.9269 38.3325C33.2193 37.8842 33.3729 37.3597 33.3685 36.8246V35.1363L37.4154 39.1832C37.6503 39.4152 37.9675 39.5449 38.2977 39.5439C38.6279 39.5429 38.9443 39.4113 39.1778 39.1778C39.4113 38.9443 39.5429 38.6279 39.5439 38.2977C39.5449 37.9675 39.4148 37.65 39.1827 37.4151ZM30.8684 36.8243C30.8684 36.8734 30.8541 36.9214 30.8273 36.9626C30.8004 37.0037 30.7622 37.0362 30.7172 37.056C30.6723 37.0758 30.6225 37.0821 30.5741 37.0741C30.5256 37.0661 30.4805 37.0442 30.4443 37.0111L18.6625 26.2278C18.4322 26.0168 18.1312 25.8998 17.8188 25.8996H11.3422C10.756 25.8991 10.194 25.666 9.77947 25.2515C9.36496 24.8369 9.13184 24.2749 9.13128 23.6887V16.3107C9.13184 15.7245 9.36496 15.1624 9.77947 14.7479C10.194 14.3334 10.756 14.1003 11.3422 14.0997H12.3325L30.8684 32.6362V36.8243Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_2353_983">
      <rect width="40" height="40" fill="white"/>
      </clipPath>
      </defs>
    </svg>`;

  const unmuteSVG = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2353_987)">
      <path d="M20.7578 0.0937374C20.2266 -0.1172 19.6172 0.0234249 19.2344 0.4453L10.2344 10.1641H1.42969C0.664062 10.1641 0.0390625 10.789 0.0390625 11.5547V28.4453C0.0390625 29.2109 0.664062 29.8359 1.42969 29.8359H10.2344L19.2344 39.5547C19.7578 40.1172 20.6328 40.1484 21.1953 39.6328C21.4766 39.3672 21.6406 39 21.6406 38.6094V1.39061C21.6406 0.8203 21.2891 0.304675 20.7578 0.0937374Z" fill="white"/>
      <path d="M38.0781 12.2968C36.8749 9.99991 35.1562 8.00772 33.0624 6.48428C32.4453 6.03116 31.5703 6.17178 31.1249 6.78897C30.6796 7.40616 30.8124 8.28116 31.4296 8.72647C37.6562 13.2265 39.0468 21.9218 34.5468 28.1405C33.6874 29.328 32.6562 30.3671 31.4687 31.2265C30.8437 31.6718 30.6953 32.539 31.1328 33.164C31.5781 33.789 32.4453 33.9374 33.0703 33.4999C33.0859 33.4921 33.0937 33.4843 33.1093 33.4687C39.7734 28.6171 41.8828 19.6171 38.0781 12.2968Z" fill="white"/>
      <path d="M28.3671 12.9608C27.7499 12.5077 26.8749 12.6483 26.4296 13.2655C25.9765 13.8827 26.1171 14.7577 26.7343 15.203C28.2655 16.3202 29.1796 18.1015 29.1796 19.9999C29.1874 21.8827 28.289 23.6562 26.7733 24.7655C26.1562 25.2187 26.0233 26.0937 26.4765 26.7108C26.9296 27.328 27.8046 27.4608 28.4218 27.0077C32.289 24.1562 33.1171 18.7108 30.2577 14.8437C29.7343 14.1171 29.0937 13.4765 28.3671 12.9608Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_2353_987">
      <rect width="40" height="40" fill="white"/>
      </clipPath>
      </defs>
      </svg>`;

  const playButton = `<svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 15.3584C0.596474 26.2795 12.515 32.8225 21.8691 27.0547C30.6821 21.6204 31.1191 8.74301 22.7021 2.68652C13.4788 -3.94925 0.534292 2.44151 0 13.8311V15.3584ZM13.583 26.6611C5.81057 26.2277 0.583493 18.1428 3.09375 10.6787C6.02842 1.95383 17.2869 -0.366913 23.3174 6.58105C30.383 14.7221 24.1951 27.2524 13.583 26.6611ZM9.5498 22.2354C9.54895 22.9145 10.2592 23.2745 10.7803 22.8291L20.8223 15.1191C21.1015 14.8294 21.1006 14.344 20.8164 14.0586L10.6514 6.2627C10.1068 5.95576 9.55013 6.35355 9.5498 6.9541V22.2354Z" fill="white"/>
</svg>
`;

  const pauseButton = `<svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.1421 29.1294C22.6686 28.3461 27.917 23.0476 28.7222 16.4351L28.8228 15.3833V13.8228L28.689 12.5767C27.81 6.08604 22.6139 0.908293 16.2065 0.109863L15.1685 0.00732422C14.6791 0.0242214 14.1829 -0.0154343 13.6938 0.00732422C7.32861 0.302393 1.80496 5.00944 0.376465 11.2876C-1.65365 20.2091 4.77739 28.8122 13.7583 29.231H15.0728L16.1421 29.1294ZM13.6558 26.9136C4.93881 26.4428 -0.402974 16.7737 3.64502 8.91357C7.83444 0.77968 19.1001 -0.00196075 24.3296 7.50635C30.236 15.9871 23.8071 27.4615 13.6558 26.9136ZM11.187 23.2085C12.1281 23.3378 12.8167 22.7937 12.894 21.8374L12.8931 7.37061C12.7526 5.52224 10.2293 5.54371 10.0718 7.33643L10.0728 21.9331C10.1245 22.5196 10.5942 23.1269 11.187 23.2085ZM17.1489 23.2407C17.8937 23.3317 18.5358 22.8859 18.7183 22.1528C18.7852 17.1391 18.7852 12.0992 18.7183 7.08545C18.2984 5.50557 16.0592 5.68305 15.937 7.36865L15.939 21.9331C16.0022 22.5963 16.4856 23.1594 17.1489 23.2407Z" fill="white"/>
</svg>
`;

  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          if (!video.src) {
            const isMobile = window.innerWidth <= 600;
            const src = isMobile
              ? video.dataset.srcMobile
              : video.dataset.srcDesktop;
            video.innerHTML = `<source src="${src}" type="video/mp4">`;
            video.load();

            // Always start from beginning after loading
            video.addEventListener("loadedmetadata", function () {
              video.currentTime = 0; // ⬅ FIXED
            });
          }

          if (!manuallyPaused.has(video)) {
            video.play();
          }
        } else {
          // Keep your existing save logic untouched
          const videoId = $(video).closest(".geyser-item").attr("id");
          if (videoId && video.currentTime > 0) {
            const savedPositions = JSON.parse(
              localStorage.getItem("videoPositions") || "{}",
            );
            savedPositions[videoId] = video.currentTime;
            localStorage.setItem(
              "videoPositions",
              JSON.stringify(savedPositions),
            );
          }
          video.pause();
        }
      });
    },
    { threshold: 0.3 },
  );

  videos.forEach((video) => videoObserver.observe(video));

  // Exclusive mute functionality
  $(".mute-btn").on("click", function () {
    const targetVideo = $(this).data("video");
    const currentVideo = $(`#${targetVideo} video`)[0];

    // Mute all other videos first
    videos.forEach((video) => {
      if (video !== currentVideo) {
        video.muted = true;
        const btn = $(video).siblings(".mute-btn");
        btn.html(muteSVG);
      }
    });

    // Toggle current video
    currentVideo.muted = !currentVideo.muted;
    $(this).html(currentVideo.muted ? muteSVG : unmuteSVG);
  });

  // Play/Pause functionality
  $(".play-pause-btn").on("click", function () {
    const targetVideo = $(this).data("video");
    const currentVideo = $(`#${targetVideo} video`)[0];

    if (currentVideo.paused) {
      manuallyPaused.delete(currentVideo);
      currentVideo.play();
      $(this).html(pauseButton);
    } else {
      manuallyPaused.add(currentVideo);
      currentVideo.pause();
      $(this).html(playButton);
    }
  });
});
